export const useIsMobileDevice = () => {

    return window && window.navigator && window.navigator.userAgent
        ? /iPhone|iPad|iPod|Android/i.test(window.navigator.userAgent)
        : false
}